export const beginHeartbeating = () =>
  ({ type: 'heartbeat.BeginHeartbeating' } as const)
export type BeginHeartbeatingAction = ReturnType<typeof beginHeartbeating>

export const receiveHeartbeat = () =>
  ({ type: 'heartbeat.HeartbeatReceived' } as const)
export type HeartbeatReceivedAction = ReturnType<typeof receiveHeartbeat>

export const successfulHeartbeat = () =>
  ({ type: 'heartbeat.SuccessfulHeartbeat' } as const)
export type SuccessfulHeartbeatAction = ReturnType<typeof successfulHeartbeat>

export type HeartbeatAction = HeartbeatReceivedAction | BeginHeartbeatingAction
